import type en from '../en/profile'
import type { Translation } from '../types'

/** My profile: language, contact, password and the person’s own settings */
const profile: Translation<typeof en> = {
  "profile.language": "Sprache",
  "profile.languageHint": "Die Sprache des Dashboards und der Nachrichten, die Sie erhalten. „Wie das Unternehmen“ folgt der Sprache Ihres Unternehmens.",
  "profile.sameAsCompany": "Wie das Unternehmen",
  "profile.languageSaved": "Sprache gespeichert",
  "profile.languageNotSaved": "Die Sprache konnte nicht gespeichert werden",
  "profile.pwChanged": "Passwort geändert",
  "profile.pwChangedText": "Alle Sitzungen wurden abgemeldet; dieser Browser hat sich neu angemeldet.",
  "profile.pwFailed": "Das Passwort konnte nicht geändert werden",
  "profile.pwCheck": "Prüfen Sie Ihr aktuelles Passwort und versuchen Sie es erneut.",
  "profile.vpnDownloaded": "VPN-Datei heruntergeladen",
  "profile.vpnDownloadedText": "Importieren Sie die .ovpn-Datei in Ihren OpenVPN-Client.",
  "profile.downloadFailed": "Download fehlgeschlagen",
  "profile.vpnNotYet": "Die VPN-Datei ist noch nicht verfügbar.",
  "profile.title": "Mein Profil",
  "profile.alertContact": "Kontakt für Meldungen",
  "profile.alertContactText": "Fügen Sie eine Telefonnummer im internationalen Format hinzu, um Ausfallmeldungen per WhatsApp oder RCS zu erhalten.",
  "profile.appearance": "Darstellung",
  "profile.theme.light": "Hell",
  "profile.theme.dark": "Dunkel",
  "profile.default": "(Standard)",
  "profile.account": "Konto",
  "profile.companyAdmin": "Unternehmensadministrator",
  "profile.teamMember": "Teammitglied",
  "profile.permissions": { one: "{count} Berechtigung", other: "{count} Berechtigungen" },
  "profile.vpnAccess": "VPN-Zugang",
  "profile.lastSeen": "Zuletzt gesehen",
  "profile.downloadVpn": ".ovpn-Datei herunterladen",
  "profile.vpnCreating": "Ihr VPN-Konto wird erstellt. Das dauert meist einige Minuten.",
  "profile.noVpn": "Noch kein VPN-Konto.",
  "profile.setup": "Einrichtungsanleitung",
  "profile.changePw": "Passwort ändern",
  "profile.currentPw": "Aktuelles Passwort",
  "profile.hidePw": "Passwort verbergen",
  "profile.showPw": "Passwort anzeigen",
  "profile.newPw": "Neues Passwort",
  "profile.confirmPw": "Passwort bestätigen",
  "profile.updatePw": "Passwort aktualisieren",
  "profile.phoneSaved": "Telefonnummer gespeichert",
  "profile.phoneSaveFailed": "Die Nummer konnte nicht gespeichert werden",
  "profile.codeSent": "Code gesendet",
  "profile.codeSentRcs": "Sehen Sie in der Nachrichten-App dieses Telefons nach (RCS).",
  "profile.codeSentWa": "Sehen Sie in WhatsApp unter dieser Nummer nach.",
  "profile.codeFailed": "Es konnte kein Code gesendet werden",
  "profile.phoneVerified": "Telefonnummer bestätigt",
  "profile.verifyFailed": "Bestätigung fehlgeschlagen",
  "profile.phone": "Telefonnummer",
  "profile.verified": "bestätigt",
  "profile.notVerified": "nicht bestätigt",
  "profile.save": "Speichern",
  "profile.sendAgain": "Erneut senden",
  "profile.sendCode": "Bestätigungscode senden",
  "profile.code": "Bestätigungscode",
  "profile.codePlaceholder": "6-stelliger Code",
  "profile.verify": "Bestätigen",
  "profile.verifiedOnly": "WhatsApp- und RCS-Meldungen werden nur an eine bestätigte Nummer gesendet.",
  "profile.phoneApp": "Telefon-App",
  "profile.phoneAppAddress": "Wählen Sie in der Velanox-App „Bei Ihrem eigenen Unternehmen anmelden“ und scannen Sie diesen Code oder geben Sie die Adresse ein:",
  "profile.phoneAppSoon": "Die App kommt in den App Store und zu Google Play.",
  "profile.phones": "Telefone, die angemeldet bleiben",
  "profile.noPhones": "Kein Telefon bleibt angemeldet.",
  "profile.thisPhone": "Dieses Telefon",
  "profile.phoneAdded": "hinzugefügt {when}",
  "profile.phoneUsed": "zuletzt verwendet {when}",
  "profile.removePhoneOf": "{name} entfernen",
  "profile.removePhoneConfirm": "{name} entfernen? Es wird abgemeldet und fragt erneut nach dem Passwort.",
  "profile.phoneRemoved": "Telefon entfernt",
  "profile.phoneRemoveFailed": "Das Telefon wurde nicht entfernt",
  "profile.push.on": "Push: an",
  "profile.push.off": "Push: aus",
  "profile.push.allow": "Push-Mitteilungen auf diesem Telefon erlauben",
  "profile.push.turnOff": "Push-Mitteilungen ausschalten",
  "profile.push.denied": "Push-Mitteilungen sind in den Einstellungen dieses Telefons aus",
  "profile.push.refused": "Push-Mitteilungen wurden auf diesem Telefon nicht erlaubt",
  "profile.push.shortages": "Materialmangel per Push-Mitteilung",
  "profile.push.shortagesHint": "Nur Ihre Telefone: die E-Mail zum Materialmangel bleibt, wie sie ist.",
  "profile.push.notSaved": "Die Push-Einstellung konnte nicht gespeichert werden",
  "profile.push.channel": "Warnungen",
}

export default profile
